import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "@/shapeStorage/shapes/shape";

export class ShapeDataObject extends Shape {
    width = 165;
    height = 200;

    setDrawStyle(_: any): void {}

    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 7) / 8 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + (width * 7) / 8 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(
        x: number,
        y: number,
        w: number,
        h: number,
        shapeStyles: {
            color: string;
            borderColor: string;
            borderDashType: string;
            borderWidth: number;
        },
    ) {
        const r = w > h ? (w * 15) / 200 : (h * 15) / 165;
        canv.ctx.save();
        canv.ctx.fillStyle = shapeStyles.color;
        canv.ctx.strokeStyle = shapeStyles.borderColor;
        canv.ctx.lineWidth = shapeStyles.borderWidth;
        canv.ctx.lineCap = "round";
        canv.ctx.lineJoin = "round";

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + r, y);
        canv.ctx.lineTo(x + (w * 13) / 18 - r, y);
        canv.ctx.lineTo(x + w, y + (h * 6) / 22);
        canv.ctx.lineTo(x + w, y + h - r);
        canv.ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
        canv.ctx.lineTo(x + r, y + h);
        canv.ctx.arcTo(x, y + h, x, y + h - r, r);
        canv.ctx.lineTo(x, y + r);
        canv.ctx.arcTo(x, y, x + r, y, r);
        canv.ctx.fill();

        canv.ctx.moveTo(x + w, y + (h * 6) / 22);
        canv.ctx.arcTo(x + (w * 13) / 18 - r, y + (h * 6) / 22, x + (w * 13) / 18 - r, y, 5);
        canv.ctx.lineTo(x + (w * 13) / 18 - r, y);

        canv.ctx.stroke();
        canv.ctx.closePath();
        canv.ctx.restore();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="m14.25 1v4.4c0 .58348.2371 1.14306.659 1.55564.422.41258.9943.64436 1.591.64436h4.5m-5.625-6.6h-10.125c-.59674 0-1.16903.23178-1.59099.64436-.42196.41259-.65901.97216-.65901 1.55564v17.6c0 .5835.23705 1.1431.65901 1.5556.42196.4126.99425.6444 1.59099.6444h13.5c.5967 0 1.169-.2318 1.591-.6444.4219-.4125.659-.9721.659-1.5556v-14.3z" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        `;
    }
}
